import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import Typography from "Components/DesignSystem/Typography/Typography";
import { AppContext } from "Context/AppContext";
import { ResolveConfigProvider } from "./context/ResolveConfigContext";
import ResolveConfigPage from "./components/ResolveConfigPage";
import ResolveProductCardButton from "./components/ResolveProductCardButton";

/**
 * `/gms/resolve` — the Resolve Configurations screen. Every Configuration section renders
 * generically from the backend's own manifest schema (`ResolveConfigPage` loops
 * `sections[]` through `ResolveGenericSection`); the `product_card` setting is the one
 * exception, broken out into `ResolveProductCardButton`'s header dialog. See
 * `okf/resolve/e2e.md`.
 */
const ResolveView: React.FC = () => {
  const appData = useContext(AppContext) as any;
  const readPermission = Boolean(appData?.pm?.checkPermission("gmsresolve_read"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!readPermission) {
      navigate("/workspace/module/permission/denied");
    }
  }, [readPermission]);

  if (!readPermission) return null;

  return (
    <ResolveConfigProvider>
      <div>
        <div className="tw-flex tw-items-center tw-justify-between tw-py-2">
          <Typography variant="display" as="h1" className="tw-text-ink" data-testid="resolve-title">
            Resolve
          </Typography>
          <ResolveProductCardButton />
        </div>
        <div className="tw-w-full tw-border-b tw-border-edge" />
        <div data-testid="resolve-content">
          <ResolveConfigPage />
        </div>
      </div>
    </ResolveConfigProvider>
  );
};

export default ResolveView;
